var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.24,
    height: 10.24,
    fill: "#fff",
    viewBox: "0 0 10.24 10.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6712",
    "data-name": "Path 6712",
    d: "M15.421,5.642a.773.773,0,0,0-1.1,0l-3.8,3.79-3.8-3.8a.774.774,0,0,0-1.1,1.1l3.8,3.8-3.8,3.8a.774.774,0,0,0,1.1,1.1l3.8-3.8,3.8,3.8a.774.774,0,0,0,1.1-1.1l-3.8-3.8,3.8-3.8A.778.778,0,0,0,15.421,5.642Z",
    transform: "translate(-5.408 -5.408)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.7e239f16d8c1924a0fe067331e978c8e.svg";
export { ForwardRef as ReactComponent };